import React, { useState, useImperativeHandle, useEffect, useRef, forwardRef } from 'react';

const generateRandomString = (length) => {
  const charset = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charset.length);
    result += charset[randomIndex];
  }
  return result;
};

const Captcha = forwardRef((props, ref) => {
  const [captcha, setCaptcha] = useState(generateRandomString(6));
  const [userInput, setUserInput] = useState('');
  const canvasRef = useRef(null);

  useImperativeHandle(ref, () => ({
    regenerateCaptcha() {
      const newCaptcha = generateRandomString(6);
      setCaptcha(newCaptcha);
      setUserInput('');
      drawCaptcha(newCaptcha);
    },
    verifyCaptcha() {
      return userInput === captcha;
    }
  }));

  useEffect(() => {
    drawCaptcha(captcha);
  }, [captcha]);

  const drawCaptcha = (text) => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    // Set canvas dimensions and clear the canvas
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    canvas.width = 120;
    canvas.height = 44;

    // Draw background gradient for captcha
    const bgGradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
    bgGradient.addColorStop(0, '#1565C0');
    bgGradient.addColorStop(1, '#1E88E5');
    ctx.fillStyle = bgGradient;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Set font and style for captcha
    ctx.font = 'bold 22px Courier New';
    ctx.fillStyle = '#FFFFFF'; // White text for high contrast
    ctx.fillText(text, 16, 30); // Position the text

    // Subtle noise lines for captcha
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * 120, Math.random() * 44);
      ctx.lineTo(Math.random() * 120, Math.random() * 44);
      ctx.strokeStyle = 'rgba(255, 255, 255, 0.25)';
      ctx.stroke();
    }
  };

  const handleChange = (event) => {
    setUserInput(event.target.value);
  };

  return (
    <div className="w-full space-y-2">
      <label className="text-xs font-bold text-slate-600 tracking-wide select-none block">Captcha</label>
      <div className="flex flex-row gap-3 items-center w-full">
        <div className="flex items-center bg-gradient-to-r from-[#1565C0] to-[#1E88E5] border border-transparent rounded-2xl p-1 justify-between shadow-sm flex-shrink-0">
          <canvas ref={canvasRef} className="rounded-xl flex-shrink-0 cursor-default select-none"></canvas>
          <button
            type="button"
            onClick={() => ref.current.regenerateCaptcha()}
            className="flex items-center justify-center text-white/90 hover:text-white transition-all text-xl w-10 h-10 select-none outline-none flex-shrink-0 hover:rotate-180 duration-500"
          >
            &#x21bb;
          </button>
        </div>
        <div className="flex-1">
          <input
            id="captcha"
            name="captcha"
            type="text"
            autoComplete="off"
            placeholder="Enter Captcha"
            value={userInput}
            onChange={handleChange}
            className="w-full bg-sky-50/40 border border-sky-100 rounded-2xl px-4 py-2.5 focus-within:border-sky-400 focus-within:bg-white focus-within:ring-4 focus-within:ring-sky-50 transition-all duration-300 text-slate-700 placeholder-slate-400 text-sm outline-none"
          />
        </div>
      </div>
    </div>
  );
});

export default Captcha;
